import { motion } from "framer-motion";
import { HelpCircle } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingCart from "@/components/layout/FloatingCart";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import SEOHead from "@/components/SEOHead";
import { useLanguage } from "@/context/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead title={`${t.faq.title} — Bait Al-Teeb`} description="Frequently asked questions about Bait Al-Teeb fragrances, orders, and shipping." />
      <Navbar />
      <FloatingCart />
      <FloatingWhatsApp />

      <main className="pt-28 pb-20">
        <div className="container-luxury max-w-3xl">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
            <span className="text-primary text-sm tracking-[0.3em] uppercase">{t.faq.badge}</span>
            <h1 className="text-4xl md:text-5xl font-serif mt-4 flex items-center justify-center gap-3">
              <HelpCircle className="w-8 h-8 text-primary" />
              {t.faq.title}
            </h1>
            <p className="text-muted-foreground mt-4">{t.faq.subtitle}</p>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
            <Accordion type="single" collapsible className="space-y-3">
              {t.faq.items.map((item: any, index: number) => (
                <AccordionItem key={index} value={`item-${index}`} className="bg-card border border-border rounded-sm px-6">
                  <AccordionTrigger className="font-serif text-base hover:text-primary">{item.q}</AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed">{item.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FAQ;
